import React, { useRef } from "react";
// import candidateImagePlaceholder from "../../../assets/images/user_profile_holder.svg";
import { useCamera } from "src/contexts/CameraContext";

const candidateImagePlaceholder = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-3.31 0-10 1.67-10 5v2h20v-2c0-3.33-6.69-5-10-5z"
      fill="var(--color-primary)"
    />
  </svg>
);

interface IntervieweeCameraProps {
  username: string;
  isInterviewerSpeaking: boolean;
  isInterviewerThinking: boolean;
}

const IntervieweeCamera: React.FC<IntervieweeCameraProps> = ({
  username,
  isInterviewerSpeaking,
  isInterviewerThinking,
}) => {
  const { videoRef, cameraActive, hasPermission } = useCamera();
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={containerRef}
      className="absolute right-6 bottom-6 w-[20vw] h-[20vw] max-w-[15.6rem] max-h-[15.6rem] flex flex-col items-center justify-center bg-white rounded-md shadow-sm overflow-hidden"
    >
      <div className="absolute top-4 left-4 text-[#1f2024] font-[Product Sans] text-[1rem] font-bold leading-[3rem] z-10">
        {username}
      </div>

      {/* Video Element */}
      <video
        ref={videoRef}
        playsInline
        muted
        className={`absolute inset-0 w-full h-full object-cover ${
          cameraActive && hasPermission ? "block" : "hidden"
        }`}
      />

      {/* Placeholder if no permission or camera is off */}
      {(!hasPermission || !cameraActive) && (
        <div className="flex items-center justify-center w-full h-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 24 24"
            fill="none"
            className={`${
              !isInterviewerSpeaking && !isInterviewerThinking
                ? "subtle-breathing-animation-blue"
                : ""
            }`}
          >
            <path
              d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-3.31 0-10 1.67-10 5v2h20v-2c0-3.33-6.69-5-10-5z"
              fill="var(--color-primary)"
            />
          </svg>
        </div>
      )}

      {/* Camera status indicator */}
      <div className="absolute bottom-2 right-2 z-10">
        <div
          className={`w-3 h-3 rounded-full ${
            cameraActive && hasPermission ? "bg-green-500" : "bg-red-500"
          }`}
        ></div>
      </div>
    </div>
  );
};

export default IntervieweeCamera;
